import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { environment } from '../../../environments/environment';
import { routerTransition } from '../../router.animations';

@Component({
  selector: 'app-workout',
  templateUrl: './workout.component.html',
  styleUrls: ['./workout.component.css'],
  animations: [routerTransition()],
  host: {'[@routerTransition]': ''}
})
export class WorkoutComponent implements OnInit {
  workouts: Array<any> = null;
  baseUrl: string = environment.baseUrl;

  constructor(private route: ActivatedRoute) {
  }

  ngOnInit() {
    this.route.data
    .subscribe(data => {
      this.workouts = data.workouts;
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/components/workout/workout.component.ts